module.exports = __webpack_public_path__ + "static/media/instagram.b26b06a7.svg";